import './services-gal.component.scss'

import Swiper, { Navigation } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'

class ServicesGal {
  constructor(elements, settings) {
    this.elements = elements
    this.settings = settings

    if(this.elements.bigCard) this.elements.bigCard.copy = this.elements.bigCard.el.cloneNode(true)

    this.init()
  }

  defineMedia() {
    this.media = {
      query: `(min-width: ${this.settings.breakpoint}px)`
    }
    this.media.watcher = window.matchMedia(this.media.query)
  }

  defineSlider() {
    this.slider = new Swiper(this.elements.wrap, {
      modules: [Navigation],
      navigation: this.elements.navigation,
      slidesPerView: 1,
      spaceBetween: 32,
      breakpoints: {
        667: {
          slidesPerView: 2,
          spaceBetween: 32,
        }
      }
    })
  }

  placeBigCard() {
    if(this.elements.bigCard && this.elements.bigCard.wrap) this.elements.bigCard.wrap.append(this.elements.bigCard.copy)
  }

  firstToggle() {
    if (window.innerWidth < this.settings.breakpoint) {
      this.defineSlider()
    } else {
      this.elements.arrowsWrap.classList.add('hidden')
      this.placeBigCard()
    }
  }

  isBigCardWrapNotEmpty() {
    return !!this.elements.bigCard.wrap.childNodes.length === 0
  }

  defineToggle() {
    this.media.watcher.addEventListener('change', event => {
      if (!event.matches) {
        this.defineSlider()
        this.elements.arrowsWrap.classList.remove('hidden')

        if (this.isBigCardWrapNotEmpty()) {
          this.elements.bigCard.copy.remove()
        }
      } else {
        if (this.slider) {
          this.slider.destroy()
          this.slider = null
          this.elements.arrowsWrap.classList.add('hidden')
        }
        if (!this.isBigCardWrapNotEmpty()) {
          this.placeBigCard()
        }
      }
    })
  }

  init() {
    this.defineMedia()

    this.firstToggle()
    this.defineToggle()
  }
}

const serviceSlidersList = document.querySelectorAll('.services-slider.swiper')
serviceSlidersList.forEach(galEl => {
  const bigCardWrap = galEl.closest('.services-gal').querySelector('.services-gal__head-card-place')

  new ServicesGal({
    wrap: galEl,
    arrowsWrap: galEl.querySelector('.services-arrows'),
    navigation: {
      prevEl: galEl.querySelector('.services-arrows__arrow-prev'),
      nextEl: galEl.querySelector('.services-arrows__arrow-next')
    },
    bigCard: {
      el: galEl.querySelector('.service-card'),
      wrap: bigCardWrap
    }
  }, {
    breakpoint: 1024
  })
})
